import React from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { useIsMobileScreen } from '../../../hooks/useWindowSize';
import { MapMarkerContainer, MapMarkerNumOfDealers, MapMarkerContent } from './MapMarker.styled';
import AlphaClusterMarker from './AlphaClusterMarker';

export type Props = {
  numDealers: number;
  onClick: () => void;
};

export const ClusterMarker = ({ numDealers, onClick }: Props) => {
  const isMobileScreen = useIsMobileScreen();

  return (
    <MapMarkerContainer
      isMobileScreen={isMobileScreen}
      data-testid="cluster-marker"
      onClick={onClick}
    >
      {process.env.IS_LEGACY ? (
        <MapMarkerContent>
          <MapMarkerNumOfDealers
            tag="span"
            variant={{ order: '2', type: 'headline', weight: 'normal' }}
          >
            {numDealers}
          </MapMarkerNumOfDealers>
        </MapMarkerContent>
      ) : (
        <AlphaClusterMarker>
          <Text
            tag="span"
            variant={{ order: '2', type: 'copy', style: 'normal' }}
            className="dealer-number-alpha"
          >
            {numDealers}
          </Text>
        </AlphaClusterMarker>
      )}
    </MapMarkerContainer>
  );
};
